import React from 'react';
import AccessorialsAndFees from '../../views/AccessorialsAndFees';
import { connect } from 'react-redux';
import { getSelf } from '../Header/HeaderActions';
import { getTerminals } from '../Dashboard/DashboardActions';
import { updateAccessorial} from './AccessorialsAndFeesActions';
import { setAccessorialRateUi, setTerminal } from './AccessorialsAndFeesUiActions';

import { getAccessorials } from './AccessorialsAndFeesActions';

class AccessorialsAndFeesViewContainer extends React.Component {

  componentDidMount() {
    const { dispatchGetTerminals, dispatchGetAccessorials} = this.props;
    dispatchGetTerminals();
    dispatchGetAccessorials();
   
  }


  render() {
    let {dispatchGetAccessorials,accessorials, importAccessorials, self, terminals, dispatchSetUiState, uiState, dispatchUpdateAccessorial, dispatchGetTerminals } = this.props;

    return <AccessorialsAndFees
      uiState={uiState}
      terminals={terminals}
      importAccessorials={importAccessorials}
      self={self}
      dispatchGetTerminals={dispatchGetTerminals}
      dispatchSetUiState={dispatchSetUiState}
      dispatchGetAccessorials={dispatchGetAccessorials}
      accessorials={accessorials}
      dispatchUpdateAccessorial={dispatchUpdateAccessorial}
    />;

  }
}

const mapStateToProps = state => {
  return {
    self: state.self,
    accessorials: state.accessorials,
    importAccessorials: state.importAccessorials,
    terminals: state.business.terminals,
    uiState: state.accessorialRateUi.accessorialRateUi.toObject()
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatchGetSelf: (cb) => dispatch(getSelf(cb)),
    dispatchGetTerminals: () => dispatch(getTerminals()),
    dispatchUpdateAccessorial: (parameters, callback) => {
      dispatch(updateAccessorial(parameters, callback));
    },
    dispatchSetTerminalId: terminalId => dispatch(setTerminal(terminalId)),
    dispatchSetUiState: state => dispatch(setAccessorialRateUi(state)),
    dispatchGetAccessorials: (parameters, cb) => dispatch(getAccessorials(parameters, cb))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessorialsAndFeesViewContainer);


// WEBPACK FOOTER //
// ./src/containers/AccessorialsAndFees/AccessorialsAndFeesViewContainer.js